export interface RefreshConfiguration {
    disabled: boolean;
    refreshFrequencyInSec: number;
}